import APIKit from "../Allapis/Apikit/apikit";

export const getFaqs = async (id) => {
  // console.log("test test ");
  const endpoint = id ? `/admin/faqs/${id}` : `admin/faqs`;
  // console.log("test etst etstet..........", endpoint);
  const res = await APIKit.get(endpoint);
  // console.log("res.............", res);
  return res.data;
};

export const createFaqs = async (values) => {
  const res = await APIKit.post(`/admin/faqs`, values);
  return res.data;
};

export const updateFaqs = async (id, values) => {
  const res = await APIKit.put(`/admin/faqs/${id}`, values);
  return res.data;
};

export const deleteFaqs = async (faqs_id) => {
  const res = await APIKit.delete(`/admin/faqs/${faqs_id}`);
  return res.data;
};
